<template>
    <div>

        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_curr_Convertor')}}</h3>
            <p>{{$t('cal_curr_conv_txt')}}</p>

        </div>
        <div class="verticallyTab mt-5">
            
            <div class="bottomTab">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbolFrom" v-validate="'required'" name="selectedSymbolFrom" :class="{ 'is-invalid': submitted && errors.has('selectedSymbolFrom'), 'active' : selectedSymbolFrom != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <option v-for="spreads in currencyList.filter((spreads) => spreads !== selectedSymbolTo)" v-show="spreads != selectedSymbolTo">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_curr_conv_From')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbolFrom')">{{$t('cal_curr_conv_Field_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field form-control" v-model="selectedSymbolTo" v-validate="'required'" name="selectedSymbolTo" :class="{ 'is-invalid': submitted && errors.has('selectedSymbolTo'), 'active' : selectedSymbolTo != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!-- <option value=""></option> -->
                                   <option v-for="spreads in currencyList.filter((spreads) => spreads !== selectedSymbolFrom)" v-show="spreads != selectedSymbolFrom" :value="spreads">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_curr_conv_To')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbolTo')">{{$t('cal_curr_conv_Field_req')}}</p>
                            </div>
                        </div> 
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <input type="text" placeholder=" " class="float-field form-control"  v-model="amount" v-validate="{ required: true,decimal:10}" name="amount" :class="{ 'is-invalid': submitted && errors.has('amount') }">
                                <label class="float-label">{{$t('cal_curr_conv_Amount')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('amount')">{{$t('cal_curr_conv_Field_req')}}</p>
                            </div>
                        </div>
                         
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculateComm()">{{$t('cal_curr_conv_Now')}}</a>
                                <p class="mt-3"><strong>{{$t('cal_curr_conv_Converted')}}</strong>: {{selectedSymbolTo}} {{amountConverted.toFixed(2)}}</p>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>  
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'

    export default {
        name: 'CurrencyConverter',
        mixins: [fxViewMixins],
        data() {
            return {
                currencyList: ["EUR","USD","GBP","CAD","CHF","AUD","NZD","NOK","JPY","ZAR","TRY","SGD","SEK","PLN","CZK","DKK","HKD","CNH","MXN","HUF","RUB","RON","ILS"],
                selectedSymbolTo:'',
                selectedSymbolFrom:'',
                amount: 0,
                amountConverted:0,
				submitted : false,
                allIsinsList:[]
            }
        },
        methods:{
            getCurrencyList(){
                this.isinList=""
                let list = this.$store.getters['/GET_ISINS_LIST'];
                this.allIsinsList = Object.keys(list);
                return this.allIsinsList;
            },
            calculateComm(){
				const _that = this
                this.submitted = true;
                let priceFeed= this.$store.getters['/GET_PRICEFEED_DATA'];
                this.$validator.validate().then(valid => {
                    if (valid) {
						let firstCurrency= _that.selectedSymbolFrom
                        let basecurreny= _that.selectedSymbolTo
                        let secondaryCurrPrice = priceFeed[firstCurrency+basecurreny]
                        if(secondaryCurrPrice){ 
                            _that.amountConverted = _that.amount*secondaryCurrPrice.A
                        }else if(priceFeed[basecurreny+firstCurrency]){    
                            secondaryCurrPrice = priceFeed[basecurreny+firstCurrency]
                            _that.amountConverted = _that.amount*(1/secondaryCurrPrice.A)
                        }else{   
                            let allIsinList = []
                            let filteredIsins=[]
                            let secondPrice=''
                            allIsinList= this.allIsinsList
                            filteredIsins = allIsinList.filter(val=>val.includes(firstCurrency)&&val.includes("USD"))
                            let filteredIsinsSecond=[]
                            filteredIsinsSecond = allIsinList.filter(val=>val.includes(basecurreny))
                            let filteredIsinsSecondPrice= priceFeed[filteredIsinsSecond[0]]
                            secondPrice= 1/filteredIsinsSecondPrice.A
                            filteredIsins.forEach(val=>{
                            if(val.slice(0,3)=='USD'){    
                                let price= priceFeed['USD'+firstCurrency]
                                _that.amountConverted = _that.amount*(price.A*secondPrice)
                            }else if(val.slice(3,6)){
                                let price= priceFeed[firstCurrency+'USD']
                                _that.amountConverted = _that.amount*(price.A*secondPrice)
                            }
                            })
                        }
					}
				})
            }
        },
        mounted() {
            this.getCurrencyList()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/currency_convertor.vue